<template>
  <div v-if='template' id='pdf-ready'>
    <ExportCover preTitle='Assessment Guide' :date='template.updatedAt' :title='template.name' />
    <div class='print-page print-portrait x-fixed-y-auto print-margin'>
      <div v-for='objective, index in template.objectives' class='break-inside-avoid pb-[5mm] mb-[10mm] border-b'>
        <p class='uppercase text-janaturq-400 text-xs'>{{ objective.theme.name }}</p>
        <h2 class='mt-[3mm] text-jananavy-900 flex items-center gap-[3mm]'>
          <div class='rounded-full border border-janaturq-400 text-jananavy-900 w-[7mm] h-[7mm] flex items-center justify-center text-xs shrink-0'>
            {{ index + 1 }}
          </div>
          {{ objective.name }}
        </h2>
        <p class='mt-[2mm] text-sm'>{{ objective.objective }}</p>
        <div class='mt-[4mm] pt-[4mm] border-t'>
          <h3 class='flex gap-[2mm] items-center text-jananavy-900 text-sm'><QuestionMarkCircleIcon class='w-[5mm] h-[5mm]' /> Question</h3>
          <pre class='whitespace-pre-wrap font-sans mt-[2mm] text-xs'>{{ objective.question }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { ref } from 'vue';

import {
  QuestionMarkCircleIcon,
  InformationCircleIcon,
  MapIcon,
  ArrowUpCircleIcon
} from '@heroicons/vue/24/outline';

import { usePayloadAction, usePayloadQuery } from '@/kernel/api';
import { getCollection } from '@/kernel/collections';
import { scoreMap } from '@/kernel/scoring';
import { getExportTitle } from '@/kernel/report';

import ExportCover from '@/components/export/export-cover.vue';

const props = defineProps({
  id: String
});

const template = ref(null);

const templateCollection = getCollection('assessment-template');
const read = usePayloadAction('GET', templateCollection.getApiObjectEndpoint(props.id));

const loadPage = async () => {
  template.value = await read.doAction();

  if (template.value) {
    document.title = getExportTitle(`Assessment - ${template.value.name}`, template.updatedAt);
  }
}

loadPage();

</script>
